// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"mobileCategorySelector-module--selectWrapper--_L4VW","dropdown":"mobileCategorySelector-module--dropdown--2V-M2"};